<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
             <el-breadcrumb-item @click.native="gohome" ><a>首页</a></el-breadcrumb-item>
             <el-breadcrumb-item>发票管理</el-breadcrumb-item>
                
        </el-breadcrumb>
         <el-card class="box-card">
           <div slot="header" class="clearfix">
                <span style="font-size: 24px;font-weight: 500;">发票管理</span>
            </div>
            <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
              <div style="width: 550px;margin: auto;">
                  <el-form-item
                  prop="lxremail"
                  label="邮箱："
                  :rules="[
                  { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                  { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                  ]"
                  >
                      <el-input v-model="dynamicValidateForm.lxremail"></el-input>
                  </el-form-item>
                
                  <el-form-item>
                      <el-button type="primary" @click="submitForm('dynamicValidateForm')">提交</el-button>
                      <el-button @click="resetForm('dynamicValidateForm')">重置</el-button>
                  </el-form-item>
                   <el-alert show-icon
    title="备注：1人-2人企业不支持电发票打印，需到所在区经办窗口领取发票。"
    type="warning"
   :closable="false">
  </el-alert>
              </div>
            
        </el-form>
        
         </el-card>
        
        
    </div>
</template>

<script>
    export default {
        data() {
            return {
                dynamicValidateForm: {
                    domains: [{
                        value: ''
                    }],
                    lxremail: ''
                }
            };
        },
        created() {
            this.user = JSON.parse(window.sessionStorage.getItem("user"));
            this.dynamicValidateForm.lxremail = this.user.lxremail;

        },
        methods: {
            //邮箱管理修改
            submitForm(formName) {
                this.$refs[formName].validate(async valid => {
                    console.log(valid);
                    if (!valid) return;
                    this.user = JSON.parse(window.sessionStorage.getItem("user"));
                    // 发起请求
                    const {
                        dataType: json,
                        data: res
                    } = await this.$http.get("updateLxremail?lxremail=" + this.dynamicValidateForm.lxremail + "&aab001=" + this.user.aab001);

                    if (res.result != "success") {

                        return this.$message.error("邮箱修改失败！！！");
                    }

                    this.$message.success("邮箱修改成功！！！");
                    // window.sessionStorage.setItem("user", JSON.stringify(res.user)); // session 放置
                    this.resetSetItem('user', JSON.stringify(res.user));
                    this.dynamicValidateForm.lxremail = res.user.lxremail;; // 重新获取邮箱

                    // this.$router.go(0);
                    //隐藏
                    // this.addDialogVisible = false;
                    // this.getUserList();
                })
            },
            resetForm(formName) {

                this.$refs[formName].resetFields();
                this.dynamicValidateForm.lxremail = '';
            },
            removeDomain(item) {
                var index = this.dynamicValidateForm.domains.indexOf(item)
                if (index !== -1) {
                    this.dynamicValidateForm.domains.splice(index, 1)
                }
            },
            addDomain() {
                this.dynamicValidateForm.domains.push({
                    value: '',
                    key: Date.now()
                });
            },

            //返回首页
            gohome() {
                window.sessionStorage.setItem('activePath', "/welcome");
                this.$router.push("/welcome");
                this.reload();   
            }

        }
    }
</script>

<style lang="less" scoped>
    /deep/.el-input__inner {
        width: 400px;
    }
    
    /deep/.el-form-item label {
        text-align: center;
    }
    
    .el-form-item {
        text-align: center;
    }
    
    .demo-dynamic {
        text-align: center;
    }
    
    /deep/.el-form-item__content {
        width: 400px;
    }
</style>